import { __awaiter } from "tslib";
import { Chart } from "chart.js";
import { MODAL_TYPE } from "./services/modal_service.js";
import { hexColors } from "./colors.js";
export const userid = Number($('body').attr('userid'));
// export function post(url: string, data: any): Promise<any> {
// 	return new Promise((resolve, reject) => {
// 		var jqxhr = $.post(url, data)
// 		.then((data, statusText, statusCode) => {
// 			resolve(data)
// 		})
// 		.fail((err) => {
// 			console.error(err)
// 			reject(err) 
// 		})
// 	})
// }
export const scrollSmoothlyToBottom = (selector) => {
    // const $ele = $(id.startsWith('#') ? id.substring(1) : id)
    // if ($ele.length === 0) {
    // 	return
    // }
    // $ele.animate({
    // 	scrollTop: $ele.prop("scrollHeight")
    // }, 500);
    const $ele = $(selector);
    if ($ele.length) {
        $ele.animate({
            scrollTop: $ele.get(0).scrollHeight
        }, 500);
    }
};
export const scrollToBottom = (id) => {
    const element = document.getElementById(id.startsWith('#') ? id.substring(1) : id);
    if (element != null) {
        element.scrollTop = element.scrollHeight;
    }
};
export const sleep = (ms) => {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve();
        }, ms);
    });
};
export function secondToDDHHMMSS(s) {
    const days = Math.floor(s / 60 / 60 / 24); // DAYS
    const hhmmss = [
        Math.floor(s / 60 / 60) % 24,
        Math.floor(s / 60) % 60,
        s % 60 // SECONDS
    ];
    return [days ? `${days}d en` : undefined, $.map(hhmmss, function (v, i) {
            return ((v < 10) ? '0' : '') + v;
        }).join(':')
    ].filter(v => v !== undefined).join(' ');
}
export function secondToHHMMSS(s) {
    var hours = Math.floor(s / 3600);
    var minutes = Math.floor((s - (hours * 3600)) / 60);
    var seconds = s - (hours * 3600) - (minutes * 60);
    if (hours < 10) {
        hours = "0" + hours;
    }
    if (minutes < 10) {
        minutes = "0" + minutes;
    }
    if (seconds < 10) {
        seconds = "0" + seconds;
    }
    return hours + ':' + minutes + ':' + seconds;
}
export function timeSinceAddition(date, hhmmss) {
    var now = Date.now();
    var seconds = Math.floor((date - Date.now()) / 1000);
    var isNegative = (seconds < 0);
    if (hhmmss) {
        if (isNegative) {
            return timeSince(date, now) + ' Geleden';
        }
        else {
            return 'Over ' + secondToDDHHMMSS(seconds);
        }
    }
    if (isNegative) {
        return timeSince(date, now) + ' Geleden';
    }
    else {
        return 'Over ' + timeSince(now, date);
    }
}
export function timeSince(date, now = Date.now()) {
    var seconds = Math.floor((now - date) / 1000);
    var interval = seconds / 31536000;
    if (interval > 1) {
        return Math.floor(interval) + " Jaren";
    }
    interval = seconds / 2592000;
    if (interval > 1) {
        return Math.floor(interval) + " Maanden";
    }
    interval = seconds / 86400;
    if (interval > 1) {
        return Math.floor(interval) + " Dagen";
    }
    interval = seconds / 3600;
    if (interval > 1) {
        return Math.floor(interval) + " Uur";
    }
    interval = seconds / 60;
    if (interval > 1) {
        return Math.floor(interval) + " Minuten";
    }
    return Math.floor(seconds) + " Seconden";
}
export function formatDateYYYMMDD(date) {
    return date.toISOString().split('T')[0];
}
export function enableTooltips() {
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        // @ts-ignore
        return new bootstrap.Tooltip(tooltipTriggerEl);
    });
}
export function updateRelativeTime() {
    let i = 0;
    const $arr = $('[data-time]').toArray().map(e => $(e));
    $arr.map($ele => {
        if (!$ele.is('span') && !$ele.is('div')) {
            console.error(`Unexpected data-time attribute on element`, $ele.get(0));
        }
        const timeStr = $ele.attr('data-time');
        if (timeStr && timeStr.length > 0 && timeStr !== '1970-01-01T00:00:00.000Z') {
            const d = moment(timeStr).toDate();
            const text = timeSinceAddition(d, $ele.is('[format="hhmmss"]'));
            $ele.text(text);
            i++;
        }
    });
    return i;
}
// export function getAnimation<T extends ChartType>(data, animationSpeed: number = 150) {
// 	if (data === undefined) {
// 		return undefined
// 	}
// 	const delayBetweenPoints = animationSpeed / data.length;
// 	const previousY = (ctx) => ctx.index === 0 ? ctx.chart.scales.y.getPixelForValue(100) : ctx.chart.getDatasetMeta(ctx.datasetIndex).data[ctx.index - 1]?.getProps(['y'] || 0, true).y;
// 	const animation: AnimationsSpec<T> = {
// 		x: {
// 			type: 'number',
// 			easing: 'linear',
// 			duration: delayBetweenPoints,
// 			from: NaN, // the point is initially skipped
// 			to: undefined,
// 		},
// 		y: {
// 			type: 'number',
// 			easing: 'linear',
// 			duration: delayBetweenPoints,
// 			from: previousY,
// 			// delay(ctx) {
// 			// 	if (ctx.type !== 'data' || ctx.yStarted) {
// 			// 		return 0;
// 			// 	}
// 			// 	ctx.yStarted = true;
// 			// 	return ctx.index * delayBetweenPoints;
// 			// }
// 		}
// 	}
// 	return animation
// }
export function fetchPositionHistory(publicationid) {
    return __awaiter(this, void 0, void 0, function* () {
        let { chartDataDaily, chartDataHourly } = yield Loading.await(api.get(`/user/${userid}/chart/` + publicationid));
        return { chartDataDaily, chartDataHourly };
    });
}
export function fetchDashboardData() {
    return __awaiter(this, void 0, void 0, function* () {
        let { chartData, enlistmentData, searchPointsData, enlistmentRatio } = yield Loading.await(api.get(`/user/${userid}/chart${location.search}`));
        return { chartData, enlistmentData, searchPointsData, enlistmentRatio };
    });
}
export function loadPubChart(id, chartData = [], opt) {
    return __awaiter(this, void 0, void 0, function* () {
        if (charts.hasOwnProperty(id)) {
            charts[id].destroy();
        }
        const [color1, color2, color3] = hexColors();
        const canvas = q(id);
        const ctx = getCanvasContext(canvas);
        const chart = new Chart(ctx, {
            type: 'line',
            data: {
                labels: opt ? chartData.map(e => opt.labelMap(e)) : chartData.map((d) => {
                    return d.date.substring(0, d.date.indexOf('T'));
                }),
                datasets: [{
                        yAxisID: 'A',
                        label: 'Jouw Positie',
                        data: chartData.map(d => d.user_position),
                        backgroundColor: color1,
                        borderColor: color1,
                        borderWidth: 3,
                        pointStyle: 'line',
                        spanGaps: true,
                    }, {
                        yAxisID: 'A',
                        label: 'Inschrijvingen',
                        data: chartData.map(d => d.total),
                        backgroundColor: color2,
                        borderColor: color2,
                        borderWidth: 3,
                        pointStyle: 'line',
                        spanGaps: true
                    }, /*{
                        yAxisID: 'B',
                        label: 'Relatieve Positie',
                        data: chartData.map(d => Math.floor(d.perc)),
                        backgroundColor: color3,
                        borderColor: color3,
                        borderWidth: 2,
                        pointStyle: 'triangle',
                        spanGaps: false
                    }*/
                ]
            },
            options: {
                // animation: getAnimation(chartData, 400),
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    A: {
                        type: 'linear',
                        position: 'left',
                        ticks: {
                            precision: 1,
                        },
                        grid: {
                            display: false
                        }
                    },
                    // B: {
                    // 	type: 'linear',
                    // 	position: 'right',
                    // 	// min: '0.0',
                    // 	min: 0,
                    // 	max: 100,
                    // 	ticks: { beginAtZero: true, backdropColor: color3, precision: 1 },
                    // 	gridLines: {
                    // 		display: false
                    // 	}
                    // }
                },
                plugins: {
                    legend: {
                        display: true,
                        position: 'bottom'
                    },
                    // tooltip: {
                    // 	callbacks: {
                    // 		title: (opt) => {
                    // 			return opt[0].label.replace(' ', ' Week ')
                    // 			// const d = new Date(opt[0].parsed.x)
                    // 			// return moment(d).format('YYYY MMM DD')
                    // 		},
                    // 	}
                    // }
                },
            }
        });
        charts[id] = chart;
        // await sleep(10)
        return chart;
    });
}
function searchQuery(query) {
    var href = window.location.href;
    var url = new URL(href);
    query.map(([key, value]) => {
        if (value !== undefined) {
            url.searchParams.set(key, value);
        }
        else {
            url.searchParams.delete(key);
        }
    });
    window.location.href = url.href;
}
export function initQueryFilters() {
    const $form = $('#filters');
    const $sort = $form.find('#sort');
    $sort.on('change', (e) => {
        const value = $sort.val();
        const [column, dir] = value.split('|');
        searchQuery([
            ['sort', column],
            ['dir', dir],
        ]);
    });
    const $search = $form.find('#search');
    $search.on('keypress', (e) => {
        const val = $search.val() || '';
        if (e.key === 'Enter') {
            searchQuery([
                ['search', val || undefined]
            ]);
        }
    });
    $form.on('submit', (e) => {
        e.preventDefault();
        e.stopPropagation();
    });
}
export function getSelectedProduct() {
    var _a;
    const $subContainer = $('.sub-container');
    const $radio = $subContainer.find('.select-box.selected input[type="radio"]');
    const strVal = $radio.attr('subscriptionid');
    return (_a = Number(strVal)) !== null && _a !== void 0 ? _a : undefined;
}
export function initSubscriptions() {
    const $subContainer = $('.sub-container');
    if ($subContainer.length === 0) {
        return;
    }
    const $btnBuy = $subContainer.find('.buy-product-btn');
    const $selectBoxes = $subContainer.find('.select-box:not(.disabled)');
    const $selectBoxArr = $selectBoxes.toArray().map(e => $(e));
    $selectBoxArr.map($selectBox => {
        $selectBox.on('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            $selectBoxes.removeClass('selected');
            $selectBox.addClass('selected');
            $selectBox.find('input[type="radio"]').prop('checked', true);
            // $btnBuy.prop('disabled', getSelectedProduct() !== 0)
        });
    });
    $selectBoxes.eq(0).trigger('click');
    $btnBuy.on('click', (e) => {
        const product = getSelectedProduct();
        api.post('/buy', { product: product }).then((res) => {
            var _a;
            console.log('res', res);
            if (res.msg) {
                modalService.create({
                    title: '',
                    content: res.msg,
                    type: MODAL_TYPE.OK
                }).onClose(() => {
                    var _a;
                    if (res.href) {
                        (_a = window.open(res.href, '_blank')) === null || _a === void 0 ? void 0 : _a.focus();
                    }
                });
            }
            else if (res.href) {
                (_a = window.open(res.href, '_blank')) === null || _a === void 0 ? void 0 : _a.focus();
            }
        }).catch(err => {
            modalService.error(err);
            console.error(err);
        });
    });
}
export function initDisabledMenuItems() {
    const $menuItems = $('.list-group-item.inactive');
    $menuItems.on('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        hideSidePanel();
        modalService.create({
            title: 'Oeps!',
            content: `U moet uw abonnement verlengen om deze pagina te kunnen bezoeken!`
        }).onClose(() => {
        });
    });
}
export function waitForFirstUserCrawl() {
    return __awaiter(this, void 0, void 0, function* () {
        const res = yield Loading.await(api.get(`/firstcrawl`));
        const handleRes = ({ success, refresh, redirect }) => {
            if (redirect)
                location.href = redirect;
            if (refresh)
                location.reload();
            if (success) {
                console.log('success!');
            }
        };
        return (res.msg) ? modalService.msg(res.msg).onClose(() => handleRes(res)) : handleRes(res);
    });
}
export function updateMobile() {
    // const $h = $('#header')
    // const isMobile = ($h.is(':visible'))
    const isMobile = window.innerWidth < 992;
    $('body').toggleClass('is-mobile', isMobile);
}
export function isMobile() {
    return ($('body').is('.is-mobile'));
}
export function initMobileSidePanel() {
    const $toggle = $('.mobile-nav-toggle');
    const $spb = $('.side-panel-backdrop');
    $toggle.on('click', (e) => {
        // const isMobile = ($('body').is('.is-mobile'))
        if (isMobile()) {
            toggleSidePanel();
        }
    });
    $spb.on('click', (e) => {
        toggleSidePanel();
    });
}
export function toggleSidePanel() {
    const $toggle = $('.mobile-nav-toggle');
    const $spb = $('.side-panel-backdrop');
    const $fa = $toggle.find('.fa');
    const $sp = $('.side-panel');
    $spb.toggle();
    $sp.toggleClass('show-overlay');
    if ($sp.hasClass('show-overlay')) {
        $fa.addClass('fa-times').removeClass('fa-bars');
    }
    else {
        $fa.addClass('fa-bars').removeClass('fa-times');
    }
}
export function hideSidePanel() {
    if (isMobile()) {
        const $toggle = $('.mobile-nav-toggle');
        const $spb = $('.side-panel-backdrop');
        const $fa = $toggle.find('.fa');
        const $sp = $('.side-panel');
        $spb.hide();
        $sp.removeClass('show-overlay');
        $fa.addClass('fa-bars').removeClass('fa-times');
    }
}
export function initContactForm() {
    const $form = $('#contact-form');
    $form.on('submit', (e) => {
        e.preventDefault();
        e.stopPropagation();
        return false;
    });
    $form.find('#submit').on('click', (e) => {
        e.preventDefault();
        // @ts-ignore
        const data = Object.fromEntries($('#contact-form').serializeArray().map((v) => [
            v.name,
            typeof v.value === 'string' ? v.value.trim() : v.value
        ]));
        const validated = Object.keys(data).map(key => {
            const isValid = (data[key]) ? true : false;
            $form.find(`[name="${key}"]`).toggleClass('is-error', !isValid);
            return isValid;
        }).reduce((prev, curr) => (prev && curr), true);
        if (!validated) {
            return false;
        }
        $form.find(`input,textarea`).val('');
        Loading.await(api.post('/contact', data)).then((res) => {
            console.log('POST response for /contact', res);
            if (res.msg) {
                modalService.create({
                    title: res.success ? 'Success!' : 'Oeps!',
                    content: res.msg
                });
            }
        }).catch(err => {
            modalService.error(err);
            console.error(err);
        });
    });
}
export function initApiButtons() {
    const $enlistBtns = $('.btn-enlist');
    $enlistBtns.toArray().map(btn => $(btn)).map($btn => $btn.on('click', (e) => __awaiter(this, void 0, void 0, function* () {
        if (location.href.includes('/user/')) {
            return modalService.notImplementedYet();
        }
        try {
            const pubid = Number($btn.attr('pubid'));
            const res = yield Loading.await(api.put(`/enlistments/${pubid}`, { pubid }));
            const handleRes = ({ success, refresh, redirect }) => {
                if (redirect)
                    location.href = redirect;
                if (refresh)
                    location.reload();
                if (success) {
                    $btn.attr('disabled', 'disabled');
                }
            };
            return (res.msg) ? modalService.msg(res.msg).onClose(() => handleRes(res)) : handleRes(res);
        }
        catch (err) {
            modalService.error(err);
        }
    })));
    const $delEnlistBtns = $('.btn-remove-enlistment');
    const $delEnlistBtnArr = $delEnlistBtns.toArray().map(btn => $(btn));
    $delEnlistBtnArr.map($btn => $btn.on('click', (e) => __awaiter(this, void 0, void 0, function* () {
        if (location.href.includes('/user/')) {
            return modalService.notImplementedYet();
        }
        try {
            const pubid = Number($btn.attr('pubid'));
            const res = yield Loading.await(api.del(`/enlistments/${pubid}`));
            const handleRes = ({ refresh, redirect }) => {
                if (redirect)
                    location.href = redirect;
                if (refresh)
                    location.reload();
            };
            return (res.msg) ? modalService.msg(res.msg).onClose(() => handleRes(res)) : handleRes(res);
        }
        catch (err) {
            modalService.error(err);
        }
    })));
    const $btns = $('.btn-history-hourly,.btn-history-daily').toArray().map(btn => $(btn));
    $btns.map($btn => {
        $btn.on('click', (e) => __awaiter(this, void 0, void 0, function* () {
            const pubid = Number($btn.attr('pubid'));
            const { chartDataDaily, chartDataHourly } = yield fetchPositionHistory(pubid);
            console.log('chartData', { chartDataDaily, chartDataHourly });
            const isHourly = $btn.is('.btn-history-hourly');
            const chartData = isHourly ? chartDataHourly : chartDataDaily;
            const events = modalService.create({
                title: `Geschiedenis ${isHourly ? 'Uurlijks' : 'Dagelijks'}`,
                content: (`<canvas id="historyChart" class="fh"></canvas>`),
                type: MODAL_TYPE.CLOSE
            });
            // await sleep(40)
            const $b = events.$.find('.content');
            const bHeight = $b.height();
            const wHeight = Math.round(window.innerHeight * 0.75);
            const height = Math.max(Math.floor(Math.min(bHeight, wHeight)), 300);
            const width = Math.floor($b.width());
            const chart = yield loadPubChart('historyChart', chartData, isHourly ? {
                labelMap: (pub) => {
                    return pub.date.substring(0, 16).replace('T', ' ');
                }
            } : undefined);
            events.onClose(() => {
                chart.destroy();
            });
            chart.resize(width, height);
        }));
    });
}
export function q(id) {
    return document.getElementById(id);
}
export function getCanvasContext(ele) {
    return ele.getContext('2d');
}
export function initBottomNav() {
    const $btnArr = $('.bottom-nav .b-nav-link').toArray().map(e => $(e));
    $btnArr.map($btn => {
        $btn.on('click', (e) => {
            $btnArr.map($btn => $btn.removeClass('active'));
            $btn.addClass('active');
            const href = $btn.attr('href');
            if (href) {
                location.href = href;
            }
        });
    });
}
//# sourceMappingURL=utils.js.map